import { Component } from '@theme/component'

export class NewsletterForm extends Component {
  constructor() {
    super()
    this.closeButton = this.querySelector('#newsletter-close-button')
    this.storageKey = 'newsletter-form-dismissed'
  }

  handleClose = () => {
    // Remove show class to trigger hide animation
    this.classList.remove('show')

    // Store dismissal in localStorage so it won't show again
    localStorage.setItem(this.storageKey, 'true')

    // Optionally set an expiration date (uncomment if you want it to show again after some time)
    // const expirationDate = new Date()
    // expirationDate.setDate(expirationDate.getDate() + 30) // 30 days
    // localStorage.setItem(this.storageKey + '-expires', expirationDate.toISOString())
  }

  show = () => {
    // Only show if not dismissed or if override is specified
    if (!this.isDismissed()) {
      this.classList.add('show')
    }
  }

  hide = () => {
    // Remove show class and add hidden class
    this.classList.remove('show')
  }

  isDismissed = () => {
    const dismissed = localStorage.getItem(this.storageKey)

    // Check if there's an expiration date set
    const expirationStr = localStorage.getItem(this.storageKey + '-expires')
    if (expirationStr) {
      const expirationDate = new Date(expirationStr)
      if (new Date() > expirationDate) {
        // Expiration passed, clear storage and allow showing again
        this.clearDismissal()
        return false
      }
    }

    return dismissed === 'true'
  }

  clearDismissal = () => {
    // Method to reset the dismissal (useful for testing or admin purposes)
    localStorage.removeItem(this.storageKey)
    localStorage.removeItem(this.storageKey + '-expires')
  }

  forceShow = () => {
    // Method to show the modal even if dismissed (for admin/testing)
    this.classList.add('show')
  }

  connectedCallback() {
    console.log('Newsletter Form connected')

    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.handleClose)
    }

    // Element starts hidden by default in CSS
    // Only show if user hasn't dismissed it
    if (!this.isDismissed()) {
      // Show after a short delay
      setTimeout(() => {
        if (!this.isDismissed()) {
          this.classList.add('show')
        }
      }, 1000) // 1 second delay before showing
    } else {
      console.log('Newsletter form was previously dismissed')
    }
  }

  disconnectedCallback() {
    if (this.closeButton) {
      this.closeButton.removeEventListener('click', this.handleClose)
    }
  }
}

if (!customElements.get('newsletter-form')) {
  customElements.define('newsletter-form', NewsletterForm)
}
